import React from 'react'
import { useDispatch } from 'react-redux'
import { CheckboxInterface } from 'common/types/entities/CheckboxInterface'
import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import { TiptapEditorUpdatePayload } from 'client/components/core/tiptap-editor'
import { useManagement } from 'client/store'
import managementSelectors from 'client/store/management/managementSelectors'
import { updateEntity } from 'client/store/page/pageActions'
import { EntityProps } from 'client/types'
import { toggleExplicitConsent } from 'publisher/actionsManagement'
import { BaseEditorCheckbox } from 'src/editor/shared/entities/base-editor-checkbox'

const Checkbox = ({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
}: EntityProps<CheckboxInterface>) => {
  const dispatch = useDispatch()
  const idEditing = useManagement(m =>
    managementSelectors.isEditing(m, entity.id),
  )
  const isConfirmed = useManagement(m => false)

  const onChange = () => dispatch(toggleExplicitConsent(entity.id))

  const updateText = (payload: TiptapEditorUpdatePayload) => {
    dispatch(
      // @ts-ignore
      updateEntity({
        ...entity,
        ...payload,
      }),
    )
  }

  return (
    <BaseEntityNew
      entity={entity}
      isMoveDownAllowed={isMoveDownAllowed}
      isMoveUpAllowed={isMoveUpAllowed}
    >
      <BaseEditorCheckbox
        entity={entity}
        checked={isConfirmed}
        onChange={onChange}
        isEditing={idEditing}
        updateText={updateText}
      />
    </BaseEntityNew>
  )
}

export default Checkbox
